export default __webpack_public_path__ + "066a3bfbfaf69d7f98fd07836418bfe5.svg";